import request from '../utils/request.js'

/***************** 订单接口 *****************/

/**
 * 竞价列表【接单大厅】
 * @param params
 * @returns {AxiosPromise}
 */
export function bid_order(params) {
    return request({
        url: '/api/bid_order',
        method: 'get',
        params: params
    })
}

/**
 * 已报价订单
 * @param params
 * @returns {AxiosPromise}
 */
export function bid_player(params) {
    return request({
        url: '/api/bid_player',
        method: 'get',
        params: params
    })
}


/**
 * 出票订单
 * @param params
 * @returns {AxiosPromise}
 */
export function ticketer_order(params) {
    return request({
        url: '/api/ticketer_order',
        method: 'get',
        params: params
    })
}

/**
 * 结算中的订单
 * @param params
 * @returns {AxiosPromise}
 */
export function settling_order(params) {
    return request({
        url: '/api/order/settling',
        method: 'get',
        params: params
    })
}

/**
 * 冻结中的订单
 * @param params
 * @returns {AxiosPromise}
 */
export function fail_order(params) {
    return request({
        url: '/api/order/fail',
        method: 'get',
        params: params
    })
}
/**
 * 删除冻结中的订单
 * @param params
 * @returns {AxiosPromise}
 */
export function delFailOrder(orderNo) {
    return request({
        url: `/api/order/fail/${orderNo}`,
        method: 'delete',
    })
}




/**
 * 竞价订单详情
 * @param params
 * @returns {AxiosPromise}
 */
export function bid_detail(bidOrderId) {
    return request({
        url: `/api/bid_order/${bidOrderId}`,
        method: 'get'
    })
}



/**
 * 报价订单详情
 * @param params
 * @returns {AxiosPromise}
 */
export function bid_player_detail(id) {
    return request({
        url: `/api/bid_player/${id}`,
        method: 'get'
    })
}


/**
 * 竞价
 * @param params
 * @returns {AxiosPromise}
 */
export function join_price(params) {
    return request({
        url: `/api/bid_order/join`,
        method: 'post',
        data: params
    })
}


/**
 * 撤销报价
 * @param params
 * @returns {AxiosPromise}
 */
export function delete_bid(id) {
    return request({
        url: `/api/bid_player/${id}`,
        method: 'delete',
    })
}



/**
 * 出票订单详情
 * @param params
 * @returns {AxiosPromise}
 */
export function ticketer_order_detail(id) {
    return request({
        url: `/api/ticketer_order/${id}`,
        method: 'get'
    })
}

/**
 * 出票
 * @param params
 * @returns {AxiosPromise}
 */
export function put_ticket(params) {
    return request({
        url: `/api/ticketer_order/put`,
        method: 'post',
        data: params
    })
}

/**
 * 修改出票
 * @param params
 * @returns {AxiosPromise}
 */
export function modify(params) {
    return request({
        url: `/api/ticketer_order/modify`,
        method: 'post',
        data: params
    })
}


/**
 * 转单
 * @param params
 * @returns {AxiosPromise}
 */
export function back(params) {
    return request({
        url: `/api/ticketer_order/back`,
        method: 'post',
        data: params
    })
}


/**
 * 释放座位
 * @param params
 * @returns {AxiosPromise}
 */
export function unlock_seats(orderNo) {
    return request({
        url: `/api/ticketer_order/unlock_seats/${orderNo}`,
        method: 'get'
    })
}



/**
 * 解码
 * @param params
 * @returns {AxiosPromise}
 */
export function decode(params) {
    return request({
        url: `/api/qrcode/decode`,
        method: 'post',
        data: params
    })
}
/**
 * 弃单
 * @param params
 * @returns {AxiosPromise}
 */
export function discard(params) {
    return request({
        url: `/api/ticketer_order/discard`,
        method: 'post',
        data: params
    })
}
/**
 * 出单延时
 * @param params
 * @returns {AxiosPromise}
 */
export function delay(params) {
    return request({
        url: `/api/ticketer_order/delay`,
        method: 'post',
        data: params
    })
}

/**
 * 积分秒单
 * @param params
 * @returns {AxiosPromise}
 */
export function integral_buy(params) {
    return request({
        url: `/api/bid_order/integral_buy`,
        method: 'post',
        data: params
    })
}

